export default {
  common: {
    columnNo: 'No.'
  },
  mapBuilder: {
    loadFile : {
      fileName: 'File Name',
      dateTime: 'Date/Time',
      type: 'Type',
      size: 'Size',
      status: 'Status'
    },
    scannerList: {
      mapName: 'Map Name',
      locked:'Locked',
      scanner: 'Scanner',
      version: 'Version',
      updateDate: 'Update Date',
    },
    mapperList: {
      mapName: 'Map Name',
      locked:'Locked',
      mapper: 'Mapper',
      version: 'Version',
      updateDate: 'Update Date',
    },
    srmList: {
      sender: 'Sender',
      receiver: 'Receiver',
      message: 'Message',
    },
    tableVersionHistory: {
      ver: 'Ver',
      checkOut: 'Check Out',
      date: 'Date',
      user: 'User',
      changeHistory: 'Change History',
      executeFile: 'Exe. File',
      delete: 'Delete',
      download: 'Download'
    },
    selectCodeTable: {
      select: 'Select',
      codeGroup: 'Code Group',
      groupCode: 'Code Name',
      sourceCode: 'Source Code',
      targetCode: 'Target Code',
    }
  },
  codetable: {
    codeGroupTable: {
      codeGroup:'Code Group',
      lastUpdate: 'Last Update',
      updateUser: 'Update User',
      manager: 'Manager',
    },
    codeNameTable: {
      no:'No.',
      codeName: 'Code Name',
    },
    codeDataTable: {
      no:'No.',
      sourceCode: 'Source Code',
      targetCode: 'Target Code',
    },
  },
  datasource: {
    dbList: {
      db:'Name',
      lastUpdate: 'Last Update',
      updateUser: 'Update User',
      manager: 'Manager',
      type: 'Type'
    },
    addSqlGroupDialog: {
      queryName: 'Query Name',
      dbName: 'DB Name',
      type: 'Type',
      queryText: 'Query Text'
    },
    queryPool: {
      no:'No.',
      queryName: 'Query Name',
      type: 'Type',
      queryText: 'Query Text',
      testing: 'Testing',
      dbType: 'DB Type',
      dbInstance: 'DB Instance',
      func: 'Func',
      seq: 'Seq',
    },
  },
  dbBroker: {
    dbList: {
      db:'Name',
      lastUpdate: 'Last Update',
      updateUser: 'Update User',
      manager: 'Manager',
    },
    addDBBrokerDialog: {
      queryName: 'Query Name',
      dbName: 'DB Name',
      type: 'Type',
      queryText: 'Query Text'
    },
    queryPool: {
      no:'No.',
      queryName: 'Query Name',
      dbName: 'DB Name',
      type: 'Type',
      queryText: 'Query Text',
      testing: 'Testing',
      use: 'Use',
      text: 'Text'
    },
  },
  mapManager: {
    header_mapName: 'Mapper Name',
    header_type: 'Type',
    header_locked: 'Locked',
    header_mapperFileName: 'Mapper File Name',
    header_version: 'Version',
    header_scannerFileName: 'Scanner File Name',
    header_manage: 'Manage',
    header_flatfileLayout: 'FlatFile Layout',
    header_mappingDefinition: 'Mapping Definiton',
    header_customer: 'Customer',
    header_appliedSrm: 'Applied SRM',
    header_updateUser: 'Update User',
    header_updateDate: 'Update Date',
    versionHistory:{
      ver: 'Ver.',
      select: 'Select',
      checkOut: 'Check Out',
      date: 'Date',
      user: 'User',
      changeHistory: 'Change History',
      executeFile: 'Exe. File',
      delete: 'Delete',
      download: 'Download',
      download1: '(Download)'
    }
  },
  referenceFiles:{
    header_fileName: 'File Name',
    header_docType: 'Document Type',
    header_comment: 'Comment',
    header_customer: 'Customer',
    header_updateUser: 'Update User',
    header_updateDate: 'Update Date',
    header_rederenceFiles: 'Reference Files',
  },
  mappingDefinition:{
      header_locked: 'Locked',
      header_mappingDefinition: 'Mapping Definition Name',
      header_mapName: 'Mapper Name',
      header_version: 'Version',
      header_customer: 'Customer',
      header_updateDate: 'Update Date',
      header_updateUser: 'Update User',
      versionHistory:{
        ver: 'Ver.',
        select: 'Select',
        checkOut: 'Check Out',
        date: 'Date',
        user: 'User',
        changeHistory: 'Change History',
        delete: 'Delete',
      },
  },
  customerDataAnalysis: {},
  repositoryMatching: {},
  srmListManagement: {},
  developmentResourcesManagement: {},
  membership: {},
  company: {},
  monitoring: {},
  partners: {},
  identification: {},
  communications: {},
  processSetup: {},
  integrationSET: {},
  repositoryManager: {},
  delHistoryWorkflowDialog: {
    ver: 'Ver.',
    processName: 'Process Name',
    date: 'Date',
    user: 'User',
    changeHistory: 'Change History',
    status: 'Status'
  },
  // 2022.06.03 213894 SLI-165: add DB Mapper UI UI-XMP-100
  xmlMappeManager: {
    header_mapName: 'Mapper Name',
    header_type: 'Type',
    header_locked: 'Locked',
    header_version: 'Version',
    header_sqlGroup: 'SQL Group',
    header_manage: 'Manage',
    header_updateUser: 'Update User',
    header_deployedUser: 'Deployed User',
    header_deployedDate: 'Deployed Date',
    versionHistory:{
      ver: 'Ver.',
      select: 'Select',
      checkOut: 'Check Out',
      date: 'Date',
      user: 'User',
      changeHistory: 'Change History',
      executeFile: 'Exe. File',
      delete: 'Delete',
      download: 'Download',
      download1: '(Download)'
    }
  },
  dbMappeManager: {
    header_mapName: 'Mapper Name',
    header_type: 'Type',
    header_locked: 'Locked',
    header_version: 'Version',
    header_sqlGroup: 'SQL Group',
    header_manage: 'Manage',
    header_updateUser: 'Update User',
    header_deployedUser: 'Deployed User',
    header_deployedDate: 'Deployed Date',
    versionHistory:{
      ver: 'Ver.',
      select: 'Select',
      checkOut: 'Check Out',
      date: 'Date',
      user: 'User',
      changeHistory: 'Change History',
      delete: 'Delete',
      download: 'Download',
      download1: '(Download)'
    }
  },
  userComponent: {
    header_mapName: 'Mapper Name',
    header_type: 'Type',
    header_locked: 'Locked',
    header_version: 'Version',
    header_sqlGroup: 'SQL Group',
    header_manage: 'Manage',
    header_updateUser: 'Update User',
    header_deployedUser: 'Deployed User',
    header_deployedDate: 'Deployed Date',
    versionHistory:{
      ver: 'Ver.',
      select: 'Select',
      checkOut: 'Check Out',
      date: 'Date',
      user: 'User',
      changeHistory: 'Change History',
      delete: 'Delete',
      download: 'Download',
      download1: '(Download)'
    }
  }
};
